const Regex = {
  Float: (isDE: boolean) => new RegExp(`[^0-9${isDE ? ',' : '.'}]+`, 'g'),
  Integer: /[^0-9]/g,
};

export default Regex;
